import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import Media from 'react-media';
import classnames from 'classnames';
import Header from '../components/Header';
import Sniplet from '../components/Sniplet';
import ExchangeSelect from '../components/ExchangeSelect/ExchangeSelect';
import StreamingControl from '../components/StreamingControl';
import TickerSearch from '../components/TickerSearch';
import IndexQuote from '../components/IndexQuote';
import QuickTrade from '../components/QuickTrade';
import Footer from '../components/Footer';
import SuggestResult from '../components/Suggest/Result';

const Layout = ({ children }) => {
  const { location } = useHistory();

  const classes = useMemo(
    () =>
      classnames(
        'quick-trade-header',
        (location.pathname.includes('/orders/new') ||
          location.pathname.includes('/transactions/new')) &&
          'hide-quick-trade',
      ),
    [location.pathname],
  );

  return (
    <Media query="(max-width: 768px)">
      {small => (
        <>
          <Header />
          <Sniplet name="Driftsmelding" />
          <Sniplet name="Hovedannonse" className="hidden-xs" />
          <div className="container">
            <section id="TickerHeaderFixedAtTop">
              <div className="visible-xs">
                <ExchangeSelect />
              </div>
              <StreamingControl />
              <TickerSearch />
              <div className="hidden-xs">{!small && <IndexQuote />}</div>
            </section>
            <section className={classes}>
              <div className="visible-xs">{small && <IndexQuote />}</div>
              <QuickTrade />
            </section>
            {children}
          </div>
          <Footer />
          <SuggestResult />
        </>
      )}
    </Media>
  );
};

export default Layout;
